// extracted by mini-css-extract-plugin
module.exports = {"storyForm":"DeepDiveEditor__storyForm---033d","storyFormLabel":"DeepDiveEditor__storyFormLabel--33swW"};